import PropTypes from 'prop-types';
import { Trans, useTranslation } from 'react-i18next';
import { nsNewsletter } from '@/app/i18n/namespaces';

// Sprint number : 2525
const Sp2525Newsletter180625 = () => {
    const { t: translate } = useTranslation(nsNewsletter);

    return (
        <div className='space-y-4'>
            <p className='font-semibold text-lg text-primary'>
                {translate('editions.sp2525.title')}
            </p>
            <p>
                <Trans t={translate} i18nKey='editions.sp2525.body' components={{ 1: <b /> }} />
            </p>
        </div>
    );
};

Sp2525Newsletter180625.propTypes = {
    params: PropTypes.shape({
        handleImageLoad: PropTypes.func.isRequired
    }).isRequired
};

export default Sp2525Newsletter180625;
